import { useQuery } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router';
import { api } from '../../api.js';

interface JE {
  id: string;
  number: string | number;
  entry_date: string;
  memo: string | null;
}

export function JournalEntries() {
  const { t } = useTranslation('bookkeeping');
  const { data, isLoading } = useQuery({
    queryKey: ['bk-jes'],
    queryFn: () => api<{ entries: JE[] }>('/bookkeeping/journal-entries?limit=50'),
  });

  return (
    <div className="space-y-4">
      <div className="flex items-center justify-between">
        <h1 className="text-xl font-semibold">{t('journalEntries.title')}</h1>
        <Link
          to="/app/bookkeeping/journal-entries/new"
          className="rounded bg-blue-600 px-3 py-1.5 text-sm text-white hover:bg-blue-700"
        >
          + {t('journalEntries.newButton')}
        </Link>
      </div>

      {isLoading ? (
        <p className="text-sm text-slate-500">{t('common:loading')}</p>
      ) : (
        <div className="overflow-x-auto rounded border bg-white">
          <table className="w-full text-sm">
            <thead className="border-b text-left text-xs uppercase text-slate-500">
              <tr>
                <th className="px-3 py-2">#</th>
                <th className="px-3 py-2">{t('journalEntries.fields.date')}</th>
                <th className="px-3 py-2">{t('journalEntries.fields.memo')}</th>
                <th className="px-3 py-2" />
              </tr>
            </thead>
            <tbody>
              {data?.entries.length === 0 && (
                <tr>
                  <td colSpan={4} className="px-3 py-4 text-center text-slate-400">
                    {t('journalEntries.empty')}
                  </td>
                </tr>
              )}
              {data?.entries.map((e) => (
                <tr key={e.id} className="border-b last:border-0 hover:bg-slate-50">
                  <td className="px-3 py-2 font-mono text-xs">
                    JE-{String(e.number).padStart(6, '0')}
                  </td>
                  <td className="px-3 py-2">{e.entry_date}</td>
                  <td className="px-3 py-2 text-slate-600">{e.memo ?? '—'}</td>
                  <td className="px-3 py-2 text-right">
                    <Link
                      to={`/app/bookkeeping/journal-entries/${e.id}`}
                      className="text-xs text-blue-600 hover:underline"
                    >
                      {t('journalEntries.viewEdit')}
                    </Link>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
